export enum Screen {
    Mobile = '(max-width: 768px)',
    Tablet = '(max-width: 1200px) and (min-width: 769px)',
    LargeScreen = '(min-width: 1600px)'
}